export var toArray = function (value) { return Array.isArray(value) ? value : [value]; };
//# sourceMappingURL=toArray.js.map